// extracted by mini-css-extract-plugin
export default {"sitemapWrapper":"SitemapWrapper-module--sitemapWrapper--210ea","sitemap":"SitemapWrapper-module--sitemap--554a1"};